import { Injectable }   from '@angular/core';
import { Router }       from '@angular/router';
import { CanActivate }  from '@angular/router';
import { Auth }         from '../auth.service';
import { AdminService }         from '../admins/admin.service';


@Injectable()
export class Authorized implements CanActivate {

  //logged:boolean=false;

  constructor(private auth: Auth, private router: Router, private adminService:AdminService) {}


    canActivate() {

    if(this.auth.authenticated()) {
    
      return true;
    } else {
    
      this.router.navigate(['login']);
      return false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/services/activators/authorized.service.ts